module.exports = __webpack_public_path__ + "assets/media/day6.78486d14.mp3";